import Vue from "vue";

class Snackbar {
    _core({ title, color, options = {} }) {
        Vue.prototype.$vs.notify({
            time: 3000,
            title: title,
            color: color,
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-right",
            ...options
        });
    }

    hyperlead(title, options = {}) {
        this._core({
            title,
            color: "linear-gradient(69.45deg, #da2d8a 13.64%, #fe5f4c 86.36%)",
            options
        })
    }
    
    primary(title, options = {}) {
        this._core({
            title,
            color: "#da2d8a",
            options
        })
    }

    info(title, options = {}) {
        this._core({
            title,
            color: "#00CFE8",
            options
        })
    }

    success(title, options = {}) {
        this._core({
            title,
            color: "success",
            options
        })
    }

    warn(title, options = {}) {
        this._core({
            title,
            color: "warning",
            options
        })
    }

    error(title, options = {}) {
        this._core({
            title,
            color: "danger",
            options
        })
    }
}

const snackbar = new Snackbar();

export default snackbar;



// WEBPACK FOOTER //
// ./src/core/helpers/snackbar.js